import React, { useEffect, useState } from "react";

import { useDocTitle } from "../../utils/hooks";
import WithMainLayout from "../../hocs/layouts/MainLayout";
import { useAPIs } from "../../apis/APIsConfig";
import {
  getBeneficios,
  getRequisitos,
  ICONS,
  validateRequest,
} from "../../services/benefits";
import { Link } from "react-router-dom";
import { AddBenefit } from "./AddBenefit";
import { useGlobalStore } from "../../utils/global";
import { saveAfiliado } from "../../services/profile";

function Benefits() {
  useAPIs();
  useDocTitle("Beneficios");
  const { user, showNotification } = useGlobalStore();
  const [benefits, setBenefits] = useState<any[]>([]);
  const [selectedBenefit, setSelectedBenefit] = useState<any>(undefined);

  useEffect(() => {
    getBeneficios().then((res) => {
      setBenefits(res.data.value);
    });
  }, []);

  function selectBenefit(benefit: any) {
    validateRequest(benefit.codBeneficio).then((res) => {
      if (res && res.data.value) {
        getRequisitos(benefit.codBeneficio).then((resRequisitos) => {
          setSelectedBenefit({
            ...benefit,
            requisitos: resRequisitos.data.value,
          });
        });
      } else {
        if (res != undefined) {
          res.data.message.forEach((msg) => {
            showNotification({
              isError: true,
              message: msg.message,
              duration: 0,
            });
          });
        } else {
          showNotification({
            isError: true,
            message:
              "No cumples con los requisitos para solicitar este beneficio (pensión por vejez).",
            duration: 0,
          });
        }
      }
    });
  }

  return (
    <>
      {selectedBenefit === undefined && (
        <div className="block pt-10 lg:pt-16 pb-20 md:pb-[340px]">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-x-6 xxl:gap-x-8 gap-y-4 md:gap-y-12">
            {benefits.map((benefit) => (
              <a
                key={benefit.codBeneficio}
                onClick={() => selectBenefit(benefit)}
                className="benefit-card"
              >
                <div className="description">
                  <div className="icon-container">
                    <i
                      className={`icon icon-${ICONS[benefit.codBeneficio]}`}
                    ></i>
                  </div>
                  <h5>{benefit.nombre}</h5>
                </div>
                <span className="btn btn-secondary btn-medium hidden md:inline-flex">
                  Aplicar<i className="icon icon-arrow-right-short left"></i>
                </span>
              </a>
            ))}
          </div>
        </div>
      )}
      {selectedBenefit !== undefined && (
        <AddBenefit
          benefit={selectedBenefit}
          cancel={() => setSelectedBenefit(undefined)}
        />
      )}
    </>
  );
}

export default WithMainLayout(Benefits, "Beneficios");
